import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Tab from './Tab'

import { isChineseLanguage } from '../../helpers/locale.js'

import styles from './Tabs.css'

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]).isRequired,
        caption: PropTypes.node.isRequired,
        tooltipId: PropTypes.string,
    })).isRequired,
    checkedItem: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    onItemChange: PropTypes.func.isRequired,
}


class Tabs extends React.PureComponent {
    render() {
        const classNameBase = classNames(styles.base, {
            [styles.base__chinese]: isChineseLanguage(),
        })

        const tabsItems = this.props.items.map((item, index) => {
            const isChecked = item.value === this.props.checkedItem
            return (
                <Tab
                    key={`tabsItem-${index}`}
                    caption={item.caption}
                    value={item.value}
                    isChecked={isChecked}
                    onClick={isChecked ? null : this.props.onItemChange.bind(this, item.value)}
                    tooltipId={item.tooltipId}
                />
            )
        })

        return (
            <div className={classNameBase}>
                <div className={styles.tabs}>
                    {tabsItems}
                </div>
            </div>
        )
    }
}

Tabs.propTypes = propTypes

export default Tabs



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Tabs/Tabs.jsx